import React from 'react';
import { Check, Trash2, History, Lock } from 'lucide-react';

const daysAgo = (iso) => {
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  return d <= 1 ? 'since yesterday' : `waiting ${d} days`;
};

// kind: 'task' | 'todo'
export const UpcomingItem = ({ item, kind, onToggle, onDelete }) => {
  const id = kind === 'task' ? item.task_id : item.todo_id;
  const locked = item.blocked_by?.length > 0;
  return (
    <div data-testid={`upcoming-${kind}-${id}`}
      className={`group flex items-start gap-3 px-4 py-2.5 transition-colors ${item.carried_over ? 'bg-amber-50/70' : 'hover:bg-stone-50'}`}>
      <button onClick={() => onToggle(item)} disabled={locked} data-testid={`upcoming-${kind}-toggle-${id}`} title={locked ? 'Finish the linked tasks first' : 'Mark as done'}
        className={`mt-0.5 w-5 h-5 shrink-0 border transition-all flex items-center justify-center ${kind === 'todo' ? 'rounded-full' : 'rounded-md'} ${locked ? 'border-stone-300 bg-stone-100 cursor-not-allowed' : 'border-stone-400 hover:border-lime-700 hover:bg-lime-50 hover:scale-110'}`}>
        {locked ? <Lock className="w-3 h-3 text-stone-400" /> : <Check className="w-3 h-3 text-lime-700 opacity-0 group-hover:opacity-60" />}
      </button>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-stone-900">{kind === 'task' ? item.title : item.text}</p>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 mt-0.5">
          {kind === 'task' && <span className="text-[11px] text-stone-500">{item.stage}</span>}
          {locked && <span className="text-[11px] text-stone-500" data-testid={`upcoming-blocked-${id}`}>· Waiting on: {item.blocked_by.join(', ')}</span>}
          {kind === 'todo' && <span className="text-[11px] text-stone-500">Quick job · {item.created_by}</span>}
          {item.carried_over && (
            <span className="inline-flex items-center gap-1 text-[11px] font-medium text-amber-800" data-testid={`upcoming-carry-${id}`}>
              <History className="w-3 h-3" /> Carried over · {daysAgo(item.since)}
            </span>
          )}
        </div>
      </div>
      {kind === 'todo' && (
        <button onClick={() => onDelete(item)} data-testid={`upcoming-todo-delete-${id}`}
          className="md:opacity-0 md:group-hover:opacity-100 p-1 text-stone-400 hover:text-red-700 transition-opacity">
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
